const basePath = 'dashboard'
export const CRM_ROUTER_DASHBOARD = {
	root: `${basePath}`
}
